<p class="text-cinza preloader text-center" ng-if="stats.loading">
  <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
</p>

<ui-select ng-if="!stats.loading" ng-model="stats.user" theme="bootstrap" id="user" name="user" ng-change="stats.onChangeUser()">
  <ui-select-match placeholder="Usuário">{{$select.selected.nomeCompleto | capitalize | characters:30}}</ui-select-match>
  <ui-select-choices repeat="usuario in stats.users | orderBy: 'nomeCompleto' | filter: $select.search">
    <span class="form-group" ng-bind-html="usuario.nomeCompleto | capitalize | highlight: $select.search"></span>
  </ui-select-choices>
</ui-select>
<p></p>
<table class="table no-margin table-bordered" ng-if="!stats.loading">
  <thead>
  <tr>
    <th>Descrição</th>
    <th class="text-right">Quantidade</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="usage in stats.usages">
    <td>{{usage[0]}}</td>
    <td class="text-right">{{usage[1]}}</td>
  </tr>
  </tbody>
</table>
